"use strict";
require.context("../../images", true);
$(function() {
  if ($(".tooltip").length > 0) {
    $(document).keyup(function(e) {
      if (e.keyCode == 27) {
        $(".tooltip").each(function() {
          $(this).attr("aria-hidden", true);
          $(this).attr("data-is-active", false);
          $(this).css("display", "none");
        });
      }
    });
  }
});
